import { render, staticRenderFns } from "./AreaSourceDetail.vue?vue&type=template&id=a7b837fe&scoped=true&"
import script from "./AreaSourceDetail.vue?vue&type=script&lang=js&"
export * from "./AreaSourceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b837fe",
  null
  
)

export default component.exports